
import { connect } from 'react-redux';
import AlternativeTitles from './alternative-titles';
import { hideNavBar, showNavBar } from '../../services/ui';

const mapState = ({ search }) => ({
  searchDetails: search.searchDetails,
});

const mapDispatch = {
  hideNavBar: () => dispatch => dispatch(hideNavBar()),
  showNavBar: () => dispatch => dispatch(showNavBar()),
};

export default connect(
  mapState,
  mapDispatch,
)(AlternativeTitles);
